import { z } from 'zod';

import { DiagramChatMessageSchema } from './DiagramChatMessage.schema';

export type DiagramChatMessage = z.infer<typeof DiagramChatMessageSchema>;

export enum ChatUserRole {
    USER = 'user',
    EXPERT = 'expert',
}
